import React from "react";
import RewardsComp from "../../../Components/RewardsComp";

const Rewards = () => {
  return (
    <section className="mt30 mb30">
      <RewardsComp />
    </section>
  );
};

export default Rewards;
